import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'
import { get, pickBy, keys } from 'lodash'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'

import { translationsManagement as translationsManagementActions } from 'redux/modules/api'
import { modal, notification, onRefreshPage } from 'redux/modules/app'

import MODALS from 'constants/modals'

function decorator() {
  return ComposedComponent => {
    @injectIntl
    @connect(
      ({ api }) => ({
        translationsManagement: api.translationsManagement
      }),
      {
        ...translationsManagementActions,
        notification,
        modal,
        onRefreshPage
      }
    )
    @withRouter
    class TranslationsManagement extends Component {
      static propTypes = {
        intl: PropTypes.object,
        updateTranslations: PropTypes.func,
        updateAllTranslations: PropTypes.func,
        translationsManagement: PropTypes.object,
        push: PropTypes.func,
        notification: PropTypes.func,
        modal: PropTypes.func,
        router: PropTypes.object,
        location: PropTypes.object,
        onRefreshPage: PropTypes.func,
        userType: PropTypes.string
      }

      state = {
        fields: {},
        isUpdateInProgress: false
      }

      unlisteners = []

      componentDidMount() {
        /**
         * Listen to route transitions and "cancel" if request is in progress and user
         * changes page. The reason == UX => search req. takes >30s on prod (SDNO-368)
         */
        const unlisten = this.props.history.listen(this.onRouteChanged)

        this.unlisteners.push(unlisten)
      }

      componentWillUnmount() {
        while (this.unlisteners.length) {
          const unlistener = this.unlisteners.pop()

          unlistener()
        }
      }

      onRouteChanged = () => {
        if (this.state.isUpdateInProgress) {
          // Cancels loading but the API request still might finish
          this.props.notification(
            'Update was interrupted, you need to wait for translations update to finish.',
            {
              intlKey: 'notifications.translationUpdateInterrupted',
              status: 'info'
            }
          )
        }
      }

      handleSubmit = fields => {
        this.props.modal(MODALS.TRANSLATIONS_MANAGER_MODAL)
        this.setState({ fields, isUpdateInProgress: false })
      }

      handleCloseDialog = () => {
        this.setState({ fields: {}, isUpdateInProgress: false })
        this.props.modal(null)
      }

      handleUpdateTranslations = () => {
        this.setState({ isUpdateInProgress: true })
        const { translationsManagement } = this.props
        const { fields } = this.state

        const projects = get(fields, 'projects')
        const language = get(fields, 'language')
        const projectCodes = keys(pickBy(projects, v => v)).join(',')

        if (translationsManagement.isLoading) {
          return
        }

        this.props
          .updateTranslations(projectCodes, language)
          .then(() => {
            this.props.modal(null)
            this.props.notification(
              'The import was finished, please refresh your page to apply change for you',
              {
                intlKey: 'notifications.translations_has_been_updated',
                status: 'success',
                autoDismiss: 60,
                action: {
                  label: this.props.intl.formatMessage({
                    id: 'notifications.translations_has_been_updated.button',
                    defaultMessage: 'Refresh Page'
                  }),
                  callback: () => {
                    this.props.onRefreshPage(true)
                  }
                }
              }
            )
          })
          .catch(err => {
            const userMessage = get(err, 'body.userMessage', false)

            this.props.modal(null)
            this.props.notification(
              userMessage ||
                'There was an error while update. Please try again later.',
              {
                intlKey: userMessage
                  ? undefined
                  : 'notifications.translations_has_been_updated.failure',
                status: 'error'
              }
            )

            console.error(err)

            this.setState({ fields: {}, isUpdateInProgress: false })
          })
      }


      render() {
        const { isUpdateInProgress } = this.state

        return (
          <ComposedComponent
            onSubmit={this.handleSubmit}
            onUpdateTranslations={this.handleUpdateTranslations}
            onCloseDialog={this.handleCloseDialog}
            isUpdateInProgress={isUpdateInProgress}
            {...this.props}
          />
        )
      }
    }

    return TranslationsManagement
  }
}

export default decorator
